import { Pipe, PipeTransform } from '@angular/core';
import { formatPhone } from 'src/app/data/utils/phone.utils';

@Pipe({ name: 'phonePipe' })
export class PhonePipe implements PipeTransform {
  transform(phone: string): string {
    if (!phone) {
      return '';
    }

    return formatPhone(phone);
  }
}
